<template>
  <ul :class="isVerticalStyle ? 'vertical' : 'horizontal'">
    <li v-for="(subFunc, index) in submenus"
      :key="index"
      :class="activeSubmenu.label === subFunc.label ? 'active' : ''"
      @click="clickLevel2(index)">
      {{ subFunc.label }}
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: ['isVerticalStyle'],
  data() {
    return {
      submenus: [],
    };
  },
  computed: {
    ...mapGetters('admin', ['currentAdminIsSuper']),
    ...mapState('menu', ['activeMenu', 'activeSubmenu', 'activeDevice']),
  },
  watch: {
    activeMenu() {
      this.filterSubmenus();
      this.init();
    },
  },
  mounted() {
    this.filterSubmenus();
    // 根据路径获取选择子菜单
    this.init();
  },
  methods: {
    init() {
      const path = this.$route.path;
      const pathArr = path.split('/');
      const subPath = pathArr[2];
      const index = this.submenus.findIndex(item => item.subPath === subPath);
      if (~index) {
        this.$store.commit('menu/setSubmenu', this.submenus[index]);
      } else {
        // 没有匹配地址时处理
        this.$store.commit('menu/setSubmenu', this.submenus[0]);
      }
    },
    filterSubmenus() {
      const submenus = this.activeMenu && this.activeMenu.submenus ? this.activeMenu.submenus : [];
      if (this.currentAdminIsSuper) {
        this.submenus = submenus;
      } else {
        this.submenus = submenus.filter((item) => {
          return !item.needSuper;
        });
      }
    },
    clickLevel2(index) {
      const activeSubmenu = this.submenus[index];
      if (activeSubmenu && activeSubmenu.label) {
        this.$store.commit('menu/setSubmenu', activeSubmenu);
        if (activeSubmenu.path) {
          const sidebarParent = this.$router.options.routes[1].path;
          const path = `${sidebarParent}/${activeSubmenu.path}`;
          this.$router.push(path);
        } else if (activeSubmenu.subPath && this.activeDevice) {
          const sidebarParent = this.$router.options.routes[1].path;
          const path = `${sidebarParent}/${activeSubmenu.subPath}/device/${this.activeDevice.name}`;
          this.$router.push(path);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables';
@import '~styles/mixins';

ul {
  padding: 0;
  &.horizontal {
    margin: 5px 0;
    padding: 0;
    overflow-x: auto;
    white-space: nowrap;
    li {
      @include commonMenuItem;
      @include horizontalMenuItem;
    }
  }
  &.vertical {
    margin: 10px;
    li {
      @include commonMenuItem;
      @include verticalMenuItem;
    }
  }
}
</style>
